/* jshint esversion:8 */

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'mdiSvg'
	},
	theme: {
		themes: {
			light: {
				primary: '#76323f',
				secondary: '#edd9c0',
				accent: '#76323f',
				error: '#F44336',
				info: '#050307',
				success: '#76834E',
				warning: '#F47216',
				background: '#c9d8c5'
			},
			dark: {
				primary: '#76323f',
				secondary: '#d7cec7',
				accent: '#fcfcfc',
				error: '#F44336',
				info: '#050307',
				success: '#76834E',
				warning: '#F47216',
				background: '#007849'
			}
		}
	}
});
